import ProfileRequest from '@/shared/infrastructure/profile/Request'

const actions = {
  async updateProfileBasicInfo(actions, payload) {
    const response = await ProfileRequest.updateProfileBasicInfo(payload)
    return response
  },
  async updateWorkExperience(actions, payload) {
    const response = await ProfileRequest.updateWorkExperience(payload)
    return response
  },
  async addSourcedProduct(actions, payload) {
    const response = await ProfileRequest.addSourcedProduct(payload)
    return response
  },
  async updateIdentityInfo(actions, payload) {
    const response = await ProfileRequest.updateIdentityInfo(payload)
    return response
  },
  async updatePaymentInformation(actions, payload) {
    const response = await ProfileRequest.updatePaymentInformation(payload)
    return response
  },
  async changePassword(actions, payload) {
    const response = await ProfileRequest.changePassword(payload)
    return response
  }
}

export default actions
